import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChessboardComponent } from './chessboard.component';
export class ChessboardModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  exports: [
    ChessboardComponent
  ],
  declarations: [ChessboardComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChessboardModule_tsickle_Closure_declarations() {
/** @type {?} */
ChessboardModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChessboardModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
